module.exports = __webpack_public_path__ + "img/anime-scene.293dcb90.webp";